import { memo } from 'react'

import './index.scss'
import Icon from '../Icon'
import Button from '../Button'
import { ICON_SELECTOR_COLORS, ICON_SELECTOR_ICONS } from './data'

type Value = {
  color: string
  icon: string
}

type IconSelector = {
  value?: Value
  text?: string
  label: string
  onInput: (value: Value) => void
}

const IconSelector = memo(({ value, text, label, onInput }: IconSelector) => {
  return (
    <div className="IconSelector">
      <div className="IconSelector__label">{label}</div>
      <div className="IconSelector__buttons">
        {Object.keys(ICON_SELECTOR_ICONS).map((key) => {
          const icon = ICON_SELECTOR_ICONS[key]
          return Object.keys(ICON_SELECTOR_COLORS).map((color) => {
            const hex = ICON_SELECTOR_COLORS[color]
            const isSelected = value?.color === color && value.icon === key
            return (
              <Button
                label={<Icon icon={icon} color={hex} />}
                onClick={() => onInput({ icon: key, color })}
                size='s'
                type={isSelected ? 'secondary' : 'tertiary'}
              />
            )
          })
        })}
      </div>
      {text && (
        <div className="IconSelector__text">
          {text}
        </div>
      )}
    </div>
  )
})

export default IconSelector
